define.alias("ember-composable-helpers/helpers/pipe", "settings/helpers/pipe");